export enum GeoJsonType {
  FeatureCollection = 'FeatureCollection',
  Feature = 'Feature',
}
